// --------------------------------------------------------------
// Created On: 2023-08-23
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./UsergroupListRow.module.scss";

// A single user group in an user group list.
export default function UsergroupListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="usergroup-list-row">
      <span>{props.name}</span>
      {props.isDefault && <span className={styles.tag}>Default</span>}
    </div>
  );
}

interface Props {
  usergroupId: number;
  name: string;
  isDefault: boolean;
}
